import { GetManagerLogin } from '@/api/login';
import { getManagerInfoApi } from '@/api/setUser';
import main from '@/main';
import login from '@/utils/login';
import config from '@/config';
import { MENU_ROUTE } from '@/utils/constant';
function findRouter(menuList, routerName) {
  let breadcrumb = [];
  menuList.forEach((menu) => {
    if (menu.menu_path === routerName && !breadcrumb.length) {
      breadcrumb = [
        {
          menu_name: menu.menu_name,
          menu_path: menu.menu_path,
        },
      ];
    }
    if (menu.children && menu.children.length) {
      menu.children.forEach((menuChild) => {
        if (menuChild.menu_path === routerName && !breadcrumb.length) {
          breadcrumb = [
            {
              menu_name: menu.menu_name,
              menu_path: menu.menu_path,
            },
            {
              menu_name: menuChild.menu_name,
              menu_path: menuChild.menu_path,
            },
          ];
        }
      });
    }
  });
  return breadcrumb;
}
export default {
  namespaced: true,
  getters: {
    appList(state) {
      return state.managerLogin.app_list;
    },
    getEnableAppList(state) {
      if (state.managerLogin.app_list) {
        return state.managerLogin.app_list.filter((e) => e.status === '1');
      }
      return [];
    },
    getName(state) {
      return state.managerLogin.name;
    },
    getEnterpriseId(state) {
      return state.managerLogin.enterprise_id;
    },
    getMenuList(state) {
      return state.managerLogin.menu_list
        .filter((menu) => menu.hidden !== 1)
        .map((menu) => ({
          ...menu,
          children: (menu.children || []).filter((menuChild) => menuChild.hidden !== 1),
        }));
    },
    getUserId(state) {
      return state.managerLogin.id;
    },
    getBreadcrumb(state) {
      if (state.breadcrumb.length) {
        return state.breadcrumb;
      }
      const menuList = state.managerLogin.menu_list;
      let breadcrumb = [];
      if (menuList.length) {
        // 认为有三级页面权限，一定有前几级页面权限
        const routerName = main.$route.name;
        let father = '';
        let child = '';
        Object.keys(MENU_ROUTE).forEach((item) => {
          if (item === routerName) {
            father = item;
          }
          if (MENU_ROUTE[item] && MENU_ROUTE[item].includes(routerName)) {
            father = item;
            child = routerName;
          }
        });
        if (father) {
          breadcrumb = findRouter(menuList, father);
        }
        if (child) {
          const childcrumb = findRouter(menuList, child);
          const breadcrumbPath = breadcrumb.map((item) => item.menu_path);
          breadcrumb = breadcrumb.concat(
            childcrumb.filter((child) => !breadcrumbPath.includes(child.menu_path)),
          );
        }
        if (!breadcrumb.length) {
          breadcrumb = findRouter(menuList, routerName);
        }
      }
      return breadcrumb;
    },
    getPublishList(state) {
      // type 1是订阅号，2是服务号，3是小程序
      return state.managerLogin.app_list.filter((item) => {
        return item.type !== 3 && item.status === '1';
      });
    },
  },
  state: {
    // 登陆用户当前绑定的信息
    managerLogin: {
      id: null,
      enterprise_id: null,
      name: null,
      uin: null,
      role: null,
      app_list: [],
      agent_list: [],
      menu_list: [],
      element_list: [],
    },
    hasRight: false, // 当前页面是否有权限
    breadcrumb: [], // 页面面包屑
  },
  mutations: {
    setManagerLogin(state, managerLogin) {
      state.managerLogin = managerLogin;
    },
    setUserAppList(state, appList) {
      state.managerLogin.app_list = appList;
    },
    setHasRight(state, hasRight) {
      state.hasRight = hasRight;
    },
    setBreadcrumb(state, breadcrumb) {
      state.breadcrumb = breadcrumb;
    },
  },
  actions: {
    async getManagerLogin(context) {
      await GetManagerLogin()
        .then((managerLogin) => {
          context.commit('setManagerLogin', managerLogin);
          const menuList = managerLogin.menu_list;
          let errMsg = '';
          const routerName = main.$route.name;
          const { rightFilter } = config;
          if (rightFilter.includes(routerName)) {
          } else if (menuList && menuList.length) {
            let menuItem = null;
            let rightRouterName = '';
            menuList.forEach((menu) => {
              if (menu.menu_path === routerName && !menuItem) {
                menuItem = menu;
              }
              if (menu.menu_path && !rightRouterName && !rightFilter.includes(menu.menu_path)) {
                rightRouterName = menu.menu_path;
              }
              if (menu.children && menu.children.length) {
                menu.children.forEach((menuChild) => {
                  if (menuChild.menu_path === routerName && !menuItem) {
                    menuItem = menuChild;
                  }
                  if (
                    menuChild.menu_path &&
                    !rightRouterName &&
                    !rightFilter.includes(menu.menu_path)
                  ) {
                    rightRouterName = menuChild.menu_path;
                  }
                });
              }
            });
            if (menuItem) {
            } else if (rightRouterName) {
              // 默认去有权限的第一个页面
              main.g_tourl(rightRouterName, { name: true, replace: true });
            } else {
              // 虽然有菜单，但没有配置path
              errMsg = '您没有可访问的页面';
            }
          } else {
            // 所有权限都没有，提示之后，去到登陆页
            errMsg = '您没有访问该系统的权限';
          }
          if (errMsg) {
            main.$alert(errMsg, '系统提示', {
              confirmButtonText: '确认',
              callback: (action) => {
                if (action === 'confirm') {
                  login.exit();
                }
              },
            });
          } else {
            context.commit('setHasRight', true);
          }
        })
        .catch((error) => {
          main.$message({
            message: error.message,
            duration: 6000,
          });
        });
    },
    async getManagerAppList(context) {
      const { id } = main.$store.state.user.managerLogin;
      console.log(id, 'id');
      if (id) {
        await getManagerInfoApi({
          id,
        }).then((res) => {
          context.commit('setUserAppList', res.app_list);
        });
      }
    },
  },
};
